<div class="calendar-page" @fadeInAnimation>
  <div class="calendar-page-title">
    <span class="title">
      {{ 'CALENDAR.TITLE' | translate }}
      <span class="bold">{{ 'CALENDAR.SUBTITLE' | translate }}</span>
    </span>
    <div>
      <eps-button
        label="ORDERS.FILTER.BUTTONS.ADD_RELOCATION"
        (buttonClick)="createFlorder()"
        buttonIcon="plus-square"
        ></eps-button>
    </div>
  </div>

  <div *ngIf="isPortrait$ | async" class="device-in-portrait">
    {{ 'CALENDAR.ROTATE_TO_LANDSCAPE' | translate }}
  </div>

  <ng-container *ngIf="isLandscape$ | async">
    <div class="calendar-page-content" [ngStyle]="{ 'height.px': height }" cdkDropListGroup>
      <!-- LEGEND AND CONTAINER -->
      <div class="sticky-template-container" [ngStyle]="{ 'height.px': height - 100 }">
        <ng-container>
          <app-calendar-draggable-templates
            type="RELOCATIONS"
            [authorization]="authorization"
            [templates]="(sandbox.templateState$ | async).templates"
            [editing]="(sandbox.templateState$ | async).editing"
            [deleting]="(sandbox.templateState$ | async).deleting"
            [selectedTemplate]="selectedTemplate"
            [deliveryDaysRequesting]="deliveryDaysRequesting"
            (createTemplate)="createTemplate()"
            (deleteTemplate)="deleteTemplate($event)"
            (selectTemplate)="selectTemplate($event)"
            (createOrder)='createFlorderFromTemplate($event.templateId, $event.date)'
            (editTemplate)="editTemplate($event)"
          >
          </app-calendar-draggable-templates>
        </ng-container>
      </div>

      <div class="template-destination">
        <div class="calendar-container">
          <div class="calendar-wrapper">
            <app-calendar-month
              [days]="flordersState.data"
              [availableDays]="availableDays"
              (showFlorderModal)="showFlorderModal($event)"
              (loadFlorders)="loadFlorders($event)"
              (openFlorder)="openFlorder($event)"
              (requestDeliveryDates)="requestDeliveryDates()"
            >
              <ng-template let-florderInfo let-tooltipBoundingBoxChange="tooltipBoundingBoxChange">
                <app-calendar-relocation-tooltip [florderInfo]="florderInfo" (boundingBoxChange)="tooltipBoundingBoxChange($event)"></app-calendar-relocation-tooltip>
              </ng-template>
            </app-calendar-month>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
